import { render } from "./penaltyClause.vue?vue&type=template&id=3d22db3c"
import script from "./penaltyClause.vue?vue&type=script&lang=js"
export * from "./penaltyClause.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__